// extracted by mini-css-extract-plugin
module.exports = {"infoItem":"ServiceItem-module--info-item--1phQF","active":"ServiceItem-module--active--3ZyZt"};